
<div class="pb-96">
  <Popup :value="showAutoPopulatePopup" popupHeader="Add your Back-Up Care info?">
    <p>Do you want to add your Back-Up care information into your job post or create your own?</p>
    <Button value="Add my info" class="w-full mt-16" size="medium" @click="populateJobPostWithCareSessionData" />
    <Button
      value="Create my own job"
      class="w-full mt-16"
      size="medium"
      variant="outlined"
      @click="showAutoPopulatePopup = false"
    />
  </Popup>
  <RouteStepper v-model="jobPostDraft" contentClass="md:mt-24 md:w-568 px-16 mx-auto" />
</div>
